// extracted by mini-css-extract-plugin
export default {"section":"BI9cqsmvBxeh8lPai9AQ","title":"zUnM2xWuv4o0qqYthDYw","separator":"ElbstCYM2fTnB3FYAD9X","grid":"swrmqy7XUYbczmLtaS_2"};